import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect'
import DefaultProfileImage from '../../../../../../Components/Common/DefaultProfileImage';

function Comment({comment, loginId, userData, idx}) {
  return (
    <li key={idx} className={'chat-list'+(userData._id === loginId ? ' right' : ' left')}>
      <div className='conversation-list'>
        {userData._id !== loginId ? userData.hasOwnProperty('picture') ?
          <div className='chat-avatar'>
            <img src={userData.picture} draggable="false" />
          </div> :
          <div className='chat-avatar'>
            <DefaultProfileImage firstName={userData.firstName} lastName={userData.lastName} />
          </div> : null
        }
        <div className='user-chat-content'>
          <div className='ctext-wrap'>
            <div className="ctext-wrap-content shadow-none">
              <p className="mb-0 ctext-content">
                {comment}
              </p>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default Comment